import {
    StructureCopyAction,
    StructureCopyActionType,
    StructureCopyState,
    SourceType,
} from './types';

export const initialData: StructureCopyState = {
    isInCopyMode: false,
    isDestinationSelection: false,
    originStructure: null,
    destinationStructures: [],
    isInReferenceCopyMode: false,
    referenceStructureId: null,
    originStructures: [],
    isReference: false,
    sourceType: SourceType.STRUCTURE,
    storeyReferencesData: [],
};

export const reducer = (
    state: StructureCopyState,
    action: StructureCopyActionType,
): StructureCopyState => {
    switch (action.type) {
        case StructureCopyAction.EnterCopyMode:
            return {
                ...state,
                isInCopyMode: true,
            };

        case StructureCopyAction.ExitCopyMode:
            return {
                ...state,
                isInCopyMode: false,
                isDestinationSelection: false,
                originStructure: null,
                destinationStructures: [],
                isInReferenceCopyMode: false,
                originStructures: [],
                sourceType: SourceType.STRUCTURE,
                storeyReferencesData: [],
            };

        case StructureCopyAction.ToggleOriginStructure:
            const isSameOrigin = state.originStructure?.id === action.payload?.id;
            return {
                ...state,
                originStructure: isSameOrigin ? null : action.payload,
            };

        case StructureCopyAction.ToggleDestinations: {
            const exists = state.destinationStructures.some(
                (dest) =>
                    dest.parentId === action.payload.parentId &&
                    dest.svgPolygonPath === action.payload.svgPolygonPath,
            );

            return {
                ...state,
                destinationStructures: exists
                    ? state.destinationStructures.filter(
                          (dest) =>
                              !(
                                  dest.parentId === action.payload.parentId &&
                                  dest.svgPolygonPath === action.payload.svgPolygonPath
                              ),
                      )
                    : [...state.destinationStructures, action.payload],
            };
        }

        case StructureCopyAction.SetDestinationSelection:
            return {
                ...state,
                isDestinationSelection: action.payload,
            };

        case StructureCopyAction.SetReferenceFlag:
            return {
                ...state,
                isReference: action.payload,
            };

        case StructureCopyAction.SetReferenceStructureId:
            return {
                ...state,
                referenceStructureId: action.payload,
            };

        case StructureCopyAction.ClearDestinations:
            return {
                ...state,
                destinationStructures: [],
            };

        case StructureCopyAction.ClearOriginStructures:
            return {
                ...state,
                originStructures: [],
            };

        case StructureCopyAction.ClearOriginStructure:
            return {
                ...state,
                originStructure: null,
            };

        case StructureCopyAction.EnterReferenceCopyMode:
            return {
                ...state,
                isInReferenceCopyMode: true,
            };

        case StructureCopyAction.SetNameToDestination: {
            const { destination, name } = action.payload;

            const exists = state.destinationStructures.some(
                (dest) =>
                    dest.parentId === destination.parentId &&
                    dest.svgPolygonPath === destination.svgPolygonPath,
            );

            return {
                ...state,
                destinationStructures: exists
                    ? state.destinationStructures.map((dest) =>
                          dest.parentId === destination.parentId &&
                          dest.svgPolygonPath === destination.svgPolygonPath
                              ? { ...dest, name }
                              : dest,
                      )
                    : [...state.destinationStructures, { ...destination, name }],
            };
        }

        case StructureCopyAction.SetOriginStructures:
            return {
                ...state,
                originStructures: action.payload,
            };

        case StructureCopyAction.SetSourceType:
            return {
                ...state,
                sourceType: action.payload,
            };

        case StructureCopyAction.SetStoreyReferencesData:
            return {
                ...state,
                storeyReferencesData: action.payload,
            };

        case StructureCopyAction.AddDestination:
            return {
                ...state,
                destinationStructures: [...state.destinationStructures, action.payload],
            };

        default:
            return state;
    }
};
